import { render, staticRenderFns } from "./MallShopOrder.vue?vue&type=template&id=000c51fa&scoped=true&"
import script from "./MallShopOrder.vue?vue&type=script&lang=js&"
export * from "./MallShopOrder.vue?vue&type=script&lang=js&"
import style0 from "./MallShopOrder.vue?vue&type=style&index=0&id=000c51fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000c51fa",
  null
  
)

export default component.exports